import { ContentBox } from "@msuite/ui/content-box";
import { LoadingScreen } from "@msuite/ui/loading-screen";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { useParams } from "react-router";
import { SubstitutionHeader } from "@/components/substitutions";
import { useSubstitutionPlan } from "@/hooks/use-substitution-plan";
import { SubstitutionGeneral } from "./substitution-general";

export function Substitution() {
	/** Hooks */
	const { t } = useTranslation();

	const substitutionPlanId = useParams().substitutionId as string;

	/** Query */
	const { substitutionPlan } = useSubstitutionPlan(substitutionPlanId);

	/** Guard */
	if (!substitutionPlan) return <LoadingScreen />;

	/** Render */
	return (
		<ContentBox bottomPadding="none">
			<SubstitutionHeader substitutionPlan={substitutionPlan} />
			<Tabs
				groups={[
					{
						name: t("general.general"),
						panels: [
							{
								label: t("general.general"),
								panel: () => <SubstitutionGeneral substitutionPlanId={substitutionPlanId} />,
								errors: [],
								cyId: "substitution-general-tab",
							},
						],
					},
				]}
			/>
		</ContentBox>
	);
}
